// src/hooks/useProducts.js
import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
const token = Cookies.get("gameport");
export const useProducts = () => {
  return useQuery({
    queryKey: ["all-products"],
    queryFn: async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/products`);
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.message || "Something went wrong");
      return json;
    },
    // Optional: Keep data fresh for longer so navigating to admin doesn't trigger a refetch immediately
    staleTime: 1000 * 60 * 5, // 5 minutes 
  });
};



 export const useOrder = () => {
  return useQuery({
    queryKey: ["admin-orders", ],
    queryFn: async () => {
      const url = new URL(`${process.env.REACT_APP_API_URL}/order/all-orders`);
      

      const res = await fetch(url.toString(), {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.message || "Failed to fetch orders");
      return json;
    },
    enabled: Boolean(process.env.REACT_APP_API_URL),
    keepPreviousData: true,
  })
 }